import ContentTable from "./content-table/content-table";
import ContentUploadResume from "./content-upload-resume/content-upload-resume";
import CreateAndEditContentDetailForm from "./create-and-edit-content-detail-form/create-and-edit-content-detail-form";
import SegregationForm from "./segregation-form/segregation-form"

export {ContentTable} 
export {ContentUploadResume} 
export {CreateAndEditContentDetailForm} 
export {SegregationForm}